import {
  GetCommandBarJobOpeningsDocument,
  GetCommandBarJobOpeningsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

const MIN_SEARCH_SIZE = 4

export const useCommandBarJobOpenings = (variables: GetCommandBarJobOpeningsQueryVariables) => {
  const { loading, data } = useQuery(GetCommandBarJobOpeningsDocument, {
    variables,
    skip: (variables.title?.length || 0) < MIN_SEARCH_SIZE,
  })

  return {
    loading,
    data: data?.ats.jobPostingsConnection.nodes || [],
  }
}
